export default __webpack_public_path__ + "static/media/project1.26017233.PNG";